import { type Dispatch, type SetStateAction, useState } from "react";
import data from "@/public/data/landing.json";
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/common/Dialog";

import { X, Info } from "@phosphor-icons/react/dist/ssr";
import { Button } from "@/shared/components/common/button";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Input from "@/shared/components/common/input/Input";

import Skeleton from "@/shared/components/common/Skeleton";
import { phonePattern } from "@/shared/constants/regex";

interface LoginSignupProps {
  onSubmit: (mobile: number) => void;

  loading: boolean;
  setStep: Dispatch<
    SetStateAction<"login" | "confirm" | "loginWithPassword" | null>
  >;
}

export default function Login({
  onSubmit,
  loading,

  setStep,
}: LoginSignupProps) {
  const [number, setNumber] = useState<string>("");
  const [isValid, setIsValid] = useState(false);

  const {
    header: {
      loginSignupModal: {
        login: { title, rule, label, description, btn, loginWithPassword },
      },
    },
  } = data;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (/^\d*$/.test(newValue) && newValue.length <= 11) {
      setNumber(newValue);
      if ((newValue && phonePattern.test(newValue)) || newValue === "") {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    }
  };

  return (
    <Flex className="flex-col">
      <DialogHeader className="flex flex-col items-start mb-3 gap-3">
        <DialogTitle className="mx-auto">{title}</DialogTitle>
        <DialogDescription className="mx-auto">
          <Typography className="font-medium">{description}</Typography>
        </DialogDescription>
      </DialogHeader>

      {/* Input */}
      <Flex className="flex-col items-start gap-y-2 py-6">
        <Typography className="font-medium">{label}</Typography>
        <Input
          autoFocus
          className={`rounded-xs ${
            number
              ? !isValid
                ? "focus:ring-destructive!"
                : "focus:ring-success!"
              : ""
          }`}
          value={number}
          onChange={handleChange}
          type={"number"}
        />

        <Flex className="items-center gap-x-1">
          <Info className="w-6 h-6" />
          <Typography className="font-medium text-xs text-ghost">
            {rule}
          </Typography>
        </Flex>
      </Flex>

      {/* Submit button */}
      <DialogFooter>
        {loading ? (
          <Skeleton className="w-full py-5 rounded-xs" />
        ) : (
          <Flex className="flex-col w-full gap-3">
            <Button
              onClick={() => number && onSubmit(+number)}
              type="submit"
              className="w-full rounded-full"
            >
              {btn}
            </Button>
            <Button
              onClick={() => setStep("loginWithPassword")}
              variant="ghost"
              className="w-full rounded-full text-primary hover:bg-muted dark:hover:bg-muted/10"
            >
              {loginWithPassword}
            </Button>
          </Flex>
        )}
      </DialogFooter>
    </Flex>
  );
}
